import React from "react";
import Hero from "../components/homePage/Hero";
import ExploreSection from "../components/homePage/ExploreSection";
import { Box } from "@mui/system";
function HomePage() {
  return (
    <Box sx={{ background: { xs: "#EBEBEB", sm: "#fff" } }}>
      <Hero />
      <ExploreSection />
    </Box>
  );
}

export default HomePage;
